function initComparisonCarousel() {
    if($('.image-comparison__carousel-section').length > 0) {
        let $initComparisonScroll = $('.image-comparison__carousel-section');

        $initComparisonScroll.each(function (key, item) {
            if(this.id === '' || this.id === undefined) {
                var sliderIdName = 'image-comparison-carousel' + key;
                this.id = sliderIdName;
                var sliderId = '#' + sliderIdName;
                let $slidesToShow = parseInt($(sliderId).attr('data-slidesToShow'));
                var $breakpointLg, $breakpointMd, $breakpointSm, $slidesToShowLg, $slidesToShowMd, $slidesToShowSm;

                if($slidesToShow === 2) {
                    $breakpointMd = 769;
                    $slidesToShowMd = 1;
                }
                if($slidesToShow > 2) {
                    $breakpointLg = 1161;
                    $slidesToShowLg = 3;
                    $breakpointMd = 769;
                    $slidesToShowMd = 2;
                    $breakpointSm = 481;
                    $slidesToShowSm = 1;
                }

                $(sliderId).slick({
                    dots: false,
                    infinite: false,
                    speed: 1000,
                    swipe: false,
                    slidesToShow: $slidesToShow,
                    slidesToScroll: 1,
                    autoplay: false,
                    arrows: true,
                    mobileFirst: false,
                    responsive: [
                        {
                            breakpoint: $breakpointLg,
                            settings: {
                                slidesToShow: $slidesToShowLg,
                                swipe: true
                            }
                        },
                        {
                            breakpoint: $breakpointMd,
                            settings: {
                                slidesToShow: $slidesToShowMd,
                                swipe: true
                            }
                        },
                        {
                            breakpoint: $breakpointSm,
                            settings: {
                                slidesToShow: $slidesToShowSm,
                                swipe: true
                            }
                        }
                    ]
                });
            }
        });
    }
}

function initImageCompare() {
    if($('.image-comparison__images').length > 0) {
        $('.image-comparison__images').anyImageComparisonSlider({
            initialPosition: 0.5,
            dividingLine: 'solid 4px white',
            controlOthers: false,
            autoAnimation: false,
            onPointerDown: true,
            interactive: true,
            controlledByOthers: false,
            controlledByOthersReverse: false
        });
    }
}

function hideLabelOnScroll(self) {
    var imgLftWidth = $(self).children().find('.image-lft').width();
    var btnLft = $(self).children().find('.button-lft');
    var btnLftWidth = $(self).children().find('.button-lft').outerWidth();
    var btnLftPos = $(self).children().find('.button-lft').position().left + btnLftWidth;

    var btnRgt = $(self).children().find('.button-rgt');
    var btnRgtPos = $(self).children().find('.button-rgt').position().left;

    if(imgLftWidth < btnLftPos) {
        btnLft.css('visibility', 'hidden');
    } else { btnLft.css('visibility', 'visible'); }

    if(imgLftWidth > btnRgtPos) {
        btnRgt.css('visibility', 'hidden');
    } else { btnRgt.css('visibility', 'visible'); }
}

$(function () {
    initComparisonCarousel();
    initImageCompare();
    if($('.image-comparison__images').length > 0 && $('.image-comparison__carousel-slide').length > 0) {
        var onImage = $('.image-comparison__images');
        var onSlide = $('.image-comparison__carousel-slide');

        // Function to disable slick slider swipe on click of images and enable only compare images swipe action
        onImage.on('click touchmove', function(ev) {
            var slider = $(this).closest('.image-comparison__carousel-section');
            slider.slick('slickSetOption', 'accessibility', false);
            slider.slick('slickSetOption', 'draggable', false);
            slider.slick('slickSetOption', 'swipe', false);
            slider.slick('slickSetOption', 'touchMove', false);
            ev.stopPropagation();

            var self = this;
            hideLabelOnScroll(self);
        });

        // Function to enable slick slider swipe on clicking anywhere other than images after disabling it above
        onSlide.on('click touchmove', function () {
            var slider = $(this).closest('.image-comparison__carousel-section');
            slider.slick('slickSetOption', 'accessibility', true);
            slider.slick('slickSetOption', 'draggable', true);
            slider.slick('slickSetOption', 'swipe', true);
            slider.slick('slickSetOption', 'touchMove', true);
        });

        // for hiding labels on mouse long click and scroll
        var int;
        onImage.mousedown(function () {
            var self = this;
            int = setInterval(function () {
                hideLabelOnScroll(self);
            }, 100);
        }).mouseup(function () {
            clearInterval(int);
        });
    }
});
